<template>
  <div class="mypage">
    <h2 class="page-title">
      <img
        :src="require(`@images/mypage/${$route.params.lang}/txt_mypage.png`)"
        class="page-title-text"
        :alt="$t('text001')"
      >
    </h2>
    <div class="user">
      <div class="user-icon">
        <img
          :src="imageUrl"
          height="80"
          width="80"
        >
      </div>
      <div class="user-text" v-html="$t('text002', { nickname: user.nickname })" />
    </div>
    <div class="vote-period" v-html="$t('text003')" />
    <div class="voted-hero-list">
      <div
        v-for="(votedHero, index) in votedHeroes"
        :key="index"
        class="voted-hero-item"
      >
        <voted :votedHero="votedHero" />
      </div>
      <div
        v-for="day in unvoteDayList"
        :key="day"
        class="voted-hero-item"
      >
        <unvote
          :day="day"
          :isEnableVote="day === votedHeroes.length + 1 && !isVoted && termType === 1"
        />
      </div>
    </div>
    <div class="wp">
      <p class="wp-text" v-html="$t('text004')" />
      <div class="wp-buttons">
        <div class="btn three-times" :class="{'-disabled': !this.wallpaper.wallpaper_3times }">
          <btn-blue @click="showGetWallpaper(3)">
            <img :src="require(`@images/mypage/${$route.params.lang}/txt_wp-3times.png`)" :alt="$t('btn002')">
          </btn-blue>
        </div>
        <div class="btn six-times" :class="{'-disabled': !this.wallpaper.wallpaper_6times }">
          <btn-blue @click="showGetWallpaper(6)">
            <img :src="require(`@images/mypage/${$route.params.lang}/txt_wp-6times.png`)" :alt="$t('btn003')">
          </btn-blue>
        </div>
      </div>
    </div>
    <div class="bg-about">
      <BtnAbout />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import store from '@/store/index'
import Api from '@libraries/api/'
import RequestVotedHeroes from '@requests/voted-heroes'
import RequestWallpaper from '@requests/wallpaper'
import ModelModal from '@models/modal'
import localeMypage from '@locales/mypage'
import { validatelocale } from '@constants'

import Voted from '@components/mypage/voted'
import Unvote from '@components/mypage/unvote'
import ModalGetWallpaper from '@components/modals/modal-get-wallpaper'
import BtnAbout from '@components/global/button-about.vue'
import BtnBlue from '@components/global/button-blue.vue'


export default {
  name: 'mypage',
  beforeRouteEnter (to, from, next) {
    if (store.getters['login/isLogin']) {
      next()
    } else {
      next('/')
    }
  },
  $messages: localeMypage,
  components: {
    Voted,
    Unvote,
    BtnAbout,
    BtnBlue,
  },
  data() {
    return {
      votedHeroes: [],
      wallpaper: {},
    }
  },
  created() {
    //MEMO: storeで保存しているisVotedのresetTime < 現在時間だったらリロードしてstoreをリセットする
    if (this.resetTime && new Date() > new Date(this.resetTime)) {
      location.reload()
    }
    this.getVotedHeroes()
    this.getWallpaper()
  },
  watch: {
    '$route.params.lang'(){
      this.getVotedHeroes()
      this.getWallpaper()
    }
  },
  computed: {
    ...mapGetters('login', ['user', 'isVoted', 'resetTime']),
    ...mapGetters('menu', ['termType']),
    imageUrl() {
      return this.user.imageUrl || require('@images/mypage/icon_user.png')
    },
    votePeriod() {
      return 7
    },
    unvoteDayList() {
      const list = []
      for (let i = this.votedHeroes.length + 1; i <= this.votePeriod; i++) {
        list.push(i)
      }
      return list
    },
  },
  methods: {
    ...mapActions('modal', ['showModal']),
    showGetWallpaper(times) {
      let url = ''
      switch (times) {
        case 3:
          url = this.wallpaper.wallpaper_3times ? this.wallpaper.wallpaper_3times : ''
          break
        case 6:
          url = this.wallpaper.wallpaper_6times ? this.wallpaper.wallpaper_6times : ''
      }
      if (url) {
        this.showModal(new ModelModal({
          component: ModalGetWallpaper,
          props: {
            times: times,
            image: url,
          }
        }))
      }
    },
    async getVotedHeroes() {
      const cookieCheck = await validatelocale(this.$route.params.lang)
      //MEMO: cookie と path のlocaleが同じかどうかをチェック エラー時には強制リロード
      if (cookieCheck) {
        Api.call(new RequestVotedHeroes())
          .then((heroes) => {
            this.votedHeroes = heroes
          })
          .catch(({error}) => {
            throw error
          })
      } else {
        location.reload()
      }
    },
    async getWallpaper(){
      const cookieCheck = await validatelocale(this.$route.params.lang)
      //MEMO: cookie と path のlocaleが同じかどうかをチェック エラー時には強制リロード
      if (cookieCheck) {
        Api.call(new RequestWallpaper())
          .then((wallpaper) => {
            this.wallpaper = wallpaper
          })
          .catch(({error}) => {
            throw error
          })
      } else {
        location.reload()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.mypage {
  text-align: center;
  padding: 40px 0 0;
}
.page-title {
  background-image: url(~@images/bg_page-title.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  height: 60px;
  width: 608px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  &-text {
    margin-top: -8px;
  }
}
.user {
  display: flex;
  align-items: center;
  padding: 20px 40px;
  .user-text {
    text-shadow: $ts-base;
    margin-left: 20px;
    font-size: $fs-xlarge;
  }
}
.vote-period {
  background-color: rgba(0, 13, 36, .4);
  min-height: 60px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-shadow: $ts-base;
  text-align: center;
  box-sizing: border-box;
  padding: 10px 20px;
  position: relative;
  &::before,
  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 8px;
    position: absolute;
    background: url(~@images/mypage/bg_period.png) no-repeat center top
  }
  &::before {
    top: 0;
  }
  &::after {
    bottom: -6px;
  }
}
.voted-hero-list {
  display: flex;
  width: 600px;
  margin: 0 auto;
  flex-wrap: wrap;
}
.voted-hero-item {
  margin-top: 20px;
  width: 200px;
}
.wp {
  margin: 40px 0;
}
.wp-text {
  font-size: $fs-xlarge;
  text-shadow: $ts-base;
}
.wp-buttons {
  .btn {
    position: relative;
    width: 539px;
    height: 100px;
    margin: 40px auto 0;
    @include tap-event();
    img {
      display: block;
      margin: 0 auto 0 110px;
    }
    &::before {
      content: "";
      display: block;
      width: 145px;
      height: 143px;
      position: absolute;
      top: 0;
      left: 0;
      background-image: url(~@images/mypage/btn_wp-3times.png);
      background-size: cover;
      top: -20px;
      left: 20px;
      z-index: 1;
    }
    &.three-times::before {
      background-image: url(~@images/mypage/btn_wp-3times.png);
    }
    &.six-times::before {
      background-image: url(~@images/mypage/btn_wp-6times.png);
    }
    &.-disabled {
      pointer-events: none;
      img {
        opacity: .5;
      }
    }
  }
}
.bg-about {
  border-top: 1px solid #19272b;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 40px 0;
}
</style>
